import { Component } from 'preact';
import axios from 'axios';
import Item from './item'
//import Loader from '../util/loader'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default class CompareCarousel extends Component {


	updateDimensions = (e) => {

		let innerWidth

		if (e){
		 	innerWidth = e && e.target ? e.target.innerWidth : '100%'
		 } else {
			innerWidth = window && window.innerWidth ? window.innerWidth : '100%'
		 }

		this.setState({carouselWidth: innerWidth})
	}

	constructor() {
		super();
		// set initial time:
		let innerWidth = window && window.innerWidth ? window.innerWidth : '100%'
		this.state = { carouselProductsContent: 'loading', carouselWidth: innerWidth };
	}

	componentWillMount(){

		this.updateDimensions()
		window.addEventListener("resize", this.updateDimensions);

		let compareCarouselData = this.props.data
		let carouselProductsContent = []

		if (!compareCarouselData){
			throw new Error('!compareCarouselData')
		}


		let carouselProducts = compareCarouselData && compareCarouselData.products
		let carouselItemsRows = compareCarouselData && compareCarouselData.rows
		let carouselTitle =  compareCarouselData && compareCarouselData.title

		if (!carouselProducts || carouselProducts.length === 0){
			throw new Error('!carouselItems')
		}

		//promiseArray
		let basicContentPromiseArray = []

		carouselProducts.forEach( current => {

			if (current.productId){
				//if only item id have to get data, otherwise content already exist
				basicContentPromiseArray.push( axios.get('https://columbus-c4de8.firebaseio.com/products/' + current.productId + '/content/basicContent.json'))
			} else {
				basicContentPromiseArray.push( {data: current} )
			}

		})

		return Promise.all(basicContentPromiseArray).then ( results=> {

		results.forEach(current => {
			//only add if available online
			//33963184
			//if (current.data && current.data.stock !== 'Not available'){
				carouselProductsContent.push( current.data)
			//}

		})

		this.setState({ carouselProductsContent, carouselItemsRows, carouselTitle, errorMessage: null})

		}).catch( err => {
			console.error(err.message)
			this.setState({errorMessage: err.message, itemsData: null})
		})


	}


render(){

		let {urlParameters, website} = this.props
		let maxSlidesToShow = urlParameters && urlParameters.maxSlidesToShow ? parseInt(urlParameters.maxSlidesToShow, 10)  : 5
		let settings = {
			 dots: true,
			 infinite: true,
			 speed: 500,
			 slidesToShow: maxSlidesToShow,
			 slidesToScroll: maxSlidesToShow,
			 responsive: [
			  {
          breakpoint: 1000,
          settings: {
						//4 > maxSlidesToShow ? maxSlidesToShow : 4
            slidesToShow: 4 > maxSlidesToShow ? maxSlidesToShow : 4 ,
            slidesToScroll: 4 > maxSlidesToShow ? maxSlidesToShow : 4,
            infinite: true,
            dots: true
         }
        },
				{
          breakpoint: 750,
          settings: {
            slidesToShow: 3 > maxSlidesToShow ? maxSlidesToShow : 3,
            slidesToScroll: 3 > maxSlidesToShow ? maxSlidesToShow : 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 500,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            initialSlide: 2
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]

		 };

		if (this.state.carouselProductsContent === 'loading'){
			return (
				null
			);
		} else if (this.state.errorMessage){
			return null
		}
		//itemcellTemplateHeights is used to give different cell templates their own height. ie- img cells need to be taller
		let itemcellTemplateHeights = { fullSizeImage: 200, rebateLink: 70 }
		let tableHeight = 0
		let firstColumn = this.state.carouselItemsRows.map( (currentRow, index) => {

				//if itemcellTemplateHeights doesn't exist for curret item template then default to 62
				let itemCellHeight = itemcellTemplateHeights[currentRow.id] ? itemcellTemplateHeights[currentRow.id] : 62
				tableHeight += itemCellHeight
				let rowBackgroundColor = index % 2 ? '#F5FBFF' : '#DDECF3'
				rowBackgroundColor =  index === 0 ? '#f6f6f6' : rowBackgroundColor

				//first we need to add our label cell to the row
				return(
					<div style={{flex: 1, height: itemCellHeight + 'px', padding: '15px', borderRight: '1px #ddd solid', backgroundColor: rowBackgroundColor , overflow: 'hidden', alignItems:'center', display: 'flex'}}>
						<b aria-label={currentRow.label}>{currentRow.label}</b>
					</div>
				)
		})

		let listProduct = this.state.carouselProductsContent.map( (currentProduct, index) =>
				 		 <Item key={currentProduct.itemId} website={website} urlParameters={this.props.urlParameters} currentProduct={currentProduct} carouselItemsRows={this.state.carouselItemsRows} itemcellTemplateHeights={itemcellTemplateHeights}   />
		)

		return (
			<div className='row ' style={{width: this.state.carouselWidth, maxWidth: '100%'}}>
					<div className='col-xs-12'>
						<h2 className='walmart-content-header'>{this.state.carouselTitle}</h2>
					</div>

					<div className="col-xs-12" style={{ display: 'flex', flex:1, height: tableHeight, border: "1px #ddd solid"}}>

								<div style={{width: '120px', flexDirection:'column'}}>
									{firstColumn}
								</div>

								<div style={{ flex: 1, width: this.state.carouselWidth -120}}>
									<div className="sliderContainer col-xs-12">
						        <Slider {...settings}>
						          {listProduct}
						        </Slider>
									</div>
				      	</div>

					</div>

			</div>
		);
	}
}

/*

<div style={{display: 'flex', height: tableHeight}}>
		<div style={{width: '120px', flexDirection:'column'}}>
			{firstColumn}
		</div>

*/



// WEBPACK FOOTER //
// ./components/contentTypes/compareCarousel/compareCarousel.js